export default [
    {
        title: 'Catégorie A',
        name: 'Trop d\'œstrogènes',
        url: 'https://www.anaisgautron.com/estrogen-dominant',
        score: [],
        checkboxes: [
            'J\'ai souvent des ballonnements, je me sens gonflée',
            'Je me sens irritable ou j\'ai des sautes d\'humeur',
            'J\'ai des règles abondantes et douloureuses',
            'J\'ai pris du poids ou j\'ai de la difficulté à en perdre, surtout au niveau des hanches, des fesses et des cuisses',
            'On m\'a dit que j\'avais des fibromes',
            'Je pleure parfois pour rien',
            'J\'ai des migraines ou d\'autres maux de tête',
            'J\'ai souvent l\'impression d\'avoir le cerveau embrumé',
            'J\'ai eu des problèmes de vésicule biliaire ou je me suis fait enlever la vésicule biliaire'
        ],
        factor: 1,
        family: 'Œstrogène',
    },
    {
        title: 'Catégorie B',
        name: 'Trop peu d\'œstrogènes',
        url: 'https://www.anaisgautron.com/low-estrogen',
        score: [],
        checkboxes: [
            'Je me sens émotionnellement fragile',
            'J\'ai des problèmes de mémoire',
            'Mes règles durent moins de trois jours',
            'Je souffre de dépression, anxiété ou de léthargie',
            'J\'ai des sueurs nocturnes et/ou des bouffées de chaleur',
            'J\'ai ou j\'ai des infections récurrentes urinaires',
            'J\'ai parfois des problèmes de fuites urinaires',
            'J\'ai de la difficulté à dormir et je me réveille la nuit',
            'Mes seins sont devenus plus petits et/ou commencent à tomber',
            'J\'ai des douleurs articulaires ou je suis sujette aux blessures articulaires',
            'Mes tâches brunes deviennent plus visible',
            'J\'ai davantage de rides et de ridules',
            'J\'ai la peau sèche ou amincie',
            'J\'ai une perte de libido',
            'J\'ai de la sécheresse ou des douleurs vaginales lors des rapports sexuels'
        ],
        factor: -1,
        family: 'Œstrogène',
    },
    {
        title: 'Catégorie C',
        name: 'Trop peu de progestérone',
        url: 'https://www.anaisgautron.com/low-progesterone',
        score: [],
        checkboxes: [
            'J\'ai le syndrome prémenstruel sept à dix jours avant mes règles',
            'J\'ai des maux de tête ou des migraines autour de mes règles',
            'Je me sens souvent anxieuse',
            'J\'ai des règles douloureuses, abondantes ou difficiles',
            'Mes seins sont douloureux ou gonflés avant mes règles',
            'Je me sens agitée, irritée',
            'J\'ai fait une fausse couche au cours du premier trimestre',
            'J\'ai le syndrome des jambes sans repos, surtout la nuit',
            'J\'ai eu des difficultés à tomber enceinte (après avoir essayé pendant six mois ou plus )'
        ],
        factor: -1,
        family: 'Progestérone',
    },
    {
        title: 'Catégorie D',
        name: 'Trop de testostérone',
        url: 'https://www.anaisgautron.com/high-testosterone',
        score: [],
        checkboxes: [
            'J\'ai une pilosité anormale sur le visage, la poitrine et/ou l\'abdomen',
            'J\'ai de l\'acné',
            'J\'ai la peau et/ou les cheveux gras',
            'J\'ai des zones de peau plus foncée (par exemple les aisselles)',
            'J\'ai remarqué une perte de cheveux sur ma tête',
            'J\'ai des acrochordons (tétines)',
            'Je lutte contre la dépression et/ou l\'anxiété',
            'J\'ai le Syndrome des ovaires polykystiques (SOPK)',
            'J\'ai des difficultés à tomber enceinte (après avoir essayé pendant six mois ou plus)'
        ],
        factor: 1,
        family: 'Testostérone',
    },
    {
        title: 'Catégorie E',
        name: 'Trop peu de testostérone',
        url: 'https://www.anaisgautron.com/low-testosterone',
        score: [],
        checkboxes: [
            'J\'ai une faible libido ou une diminution de la libido',
            'Je lutte contre la dépression, j\'ai des sautes d\'humeur ou je pleure facilement',
            'Je n\'ai aucune motivation',
            'Je suis fatiguée tout au long de la journée ou j\'ai reçu un diagnostic de syndrome de fatigue chronique',
            'Je n\'arrive pas à gagner du muscle et je perds de la masse musculaire',
            'J\'ai une diminution de la densité osseuse ou j\'ai reçu un diagnostic d\'ostéopénie ou d\'ostéoporose',
            'J\'ai une incontinence urinaire',
            'J\'ai une perte de fantasmes sexuels',
            'J\'ai des difficultés ou je suis incapable d\'avoir un orgasme',
            'J\'ai des symptômes cardiovasculaires ou une maladie cardiaque',
            'J\'ai pris du poids',
            'J\'ai des crises d\'anxiété ou de panique',
        ],
        factor: -1,
        family: 'Testostérone',
    },
    {
        title: 'Catégorie F',
        name: 'Trop peu de cortisol',
        url: 'https://www.anaisgautron.com/low-cortisol',
        score: [],
        checkboxes: [
            'Je me sens fatiguée le matin, même après une nuit de sommeil complète',
            'Je dépends de la caféine pour passer ma journée',
            'Je veux faire des siestes presque tous les jours',
            'Mon énergie s\'effondre dans l\'après-midi',
            'J\'ai envie d\'aliments salés ou sucrés',
            'J\'ai le vertige quand je me lève trop vite',
            'J\'ai beaucoup de stress',
            'J\'ai des difficultés à m\'endormir et/ou à rester endormie',
            'Mes muscles se sentent faibles',
            'Je tombe souvent malade et/ou j\'ai du mal à surmonter les infections',
            'J\'ai des problèmes d\'hypoglycémie',
        ],
        factor: -1,
        family: 'Cortisol',
    },
    {
        title: 'Catégorie G',
        name: 'Trop de cortisol',
        url: 'https://www.anaisgautron.com/high-cortisol',
        score: [],
        checkboxes: [
            'Ma vie est follement stressante',
            'Je me sens submergée par le stress',
            'J\'ai un surplus de poids autour de mon abdomen',
            'J\'ai de la difficulté à m\'endormir ou à rester endormie',
            'Mon corps est fatigué la nuit, mais je n\'arrête pas de cogiter',
            'Je me sens complètement éveillée au milieu de la nuit qui m\'empêche de m\'endormir',
            'Je me réveille entre 2h et 4h du matin et je n\'arrive pas à me rendormir',
            'Je me sens facilement distraite, surtout quand je suis stressée',
            'Je me fâche rapidement ou je me sens juste nerveuse',
            'J\'ai une pression artérielle élevée ou un rythme cardiaque rapide',
            'J\'ai une glycémie élevée ou un diabète',
            'Je tremble si je ne mange pas souvent',
            'Je suis sujette aux blessures et j\'ai du mal à récupérer',
        ],
        factor: 1,
        family: 'Cortisol',
    },
    {
        title: 'Catégorie H',
        name: 'Trop peu d\'hormones thyroïdiennes',
        url: 'https://www.anaisgautron.com/low-thyroid-hormones',
        score: [],
        checkboxes: [
            'J\'ai un brouillard cérébral ou j\'ai l\'impression que ma mémoire n\'est plus tout à fait ce qu\'elle était',
            'Je perds des cheveux (cuir chevelu, corps, tiers externe des sourcils)',
            'Mes cheveux sont secs et s\'emmêlent facilement',
            'Je suis souvent constipée et j\'ai besoin d\'un stimulant (comme la caféine) pour aller à la selle',
            'J\'ai froid et/ou j\'ai froid aux mains et aux pieds',
            'Mes règles sont sporadiques ou surviennent à plus de trente-cinq jours d\'intervalle',
            'J\'ai des douleurs articulaires ou musculaires',
            'J\'ai la peau sèche',
            'J\'ai eu des difficultés à tomber enceinte (après avoir essayé pendant six mois ou plus) ou j\'ai fait une fausse couche au premier trimestre',
            'Je suis de mauvaise humeur ou je lutte contre la dépression',
            'Je suis fatiguée, peu importe combien de temps je dors',
            'J\'ai du mal à transpirer',
            'J\'ai des maux de tête récurrents',
            'J\'ai un taux de cholestérol élevé',
            'J\'ai une voix rauque la plupart du temps',
        ],
        factor: -1,
        family: 'Hormones thyroïdiennes',
    },
];
